// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d7d2c57","239":"ef448cec","732":"197fd710"}[chunkId] + ".chunk.js";
};